import Axios from 'axios'
import {vehicleFeeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_vehicle_fees (context) {
    Axios.get(vehicleFeeUrls.getAllVehicleFees).then(function (response) {
      context.commit('GET_ALL_VEHICLE_FEES', response.data)
    })
  },
  get_vehicle_fees (context, publicId) {
    Axios.get(vehicleFeeUrls.getVehicleFees + publicId).then(function (response) {
      context.commit('GET_VEHICLE_FEES', response.data)
    })
  },
  get_deleted_vehicle_fees (context) {
    Axios.get(vehicleFeeUrls.getDeletedVehicleFee).then(function (response) {
      context.commit('GET_DELETED_VEHICLE_FEES', response.data)
    })
  },
  get_vehicle_fee (context, publicId) {
    Axios.get(vehicleFeeUrls.getVehicleFee + publicId).then(function (response) {
      context.commit('GET_VEHICLE_FEE', response.data)
    })
  },
  post_vehicle_fee (context, data) {
    Axios.post(vehicleFeeUrls.postVehicleFee, data).then(function () {
      context.dispatch('get_all_vehicle_fees')
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_vehicle_fee (context, data) {
    Axios.patch(vehicleFeeUrls.editVehicleFee, data).then(function () {
      context.dispatch('get_all_vehicle_fees')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_vehicle_fee (context, data) {
    Axios.patch(vehicleFeeUrls.deleteVehicleFee, data).then(function () {
      context.dispatch('get_all_vehicle_fees')
    })
  },
  restoreVehicleFee (context, publicId) {
    Axios.get(vehicleFeeUrls.restoreVehicleFee + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_VEHICLE_FEES', response.data)
      router.push({
        name: 'Module.VehicleFees'
      })
    })
  }
}
